<template>
  <div class="background_index_index">
    <div class="index_text">
      <p style="font-size: 20px;">15年+｜项目350+｜$35亿+｜退出70+</p>
      <p style="padding-bottom: 1vh">————————</p>
      <p>SIG是总部设于美国的全球领先的量化交易金融公司，</p>
      <p>拥有独有的创新、严谨的交易理念和技术，是高性能、</p>
      <p>低延迟交易的全球领导者和创新者。</p>
      <p>30年来，SIG在全球市场展开投资，尤其在金融衍生品的定价</p>
      <p>和交易方面享有国际声誉。公司全球员工超过2500人。</p>
      <p>SIG 2005年进入中国，</p>
      <p>以自有资金投资中国的创新公司。</p>
      <br>
      <p>15余年来，聚焦中国互联网、消费等相关领域，已经投资了包括：</p>
      <p>字节跳动、声网、博纳影业、薄荷健康、翼鸥教育、云智慧、</p>
      <p>乡村基、大麦网、Finch、闪送、Musical.ly、伴鱼、PatPat、</p>
      <p>拉面说、天天拍车、英雄体育、喜马拉雅、晶泰科技、</p>
      <p>雅乐科技、一条、云学堂、智云健康、最右等在内的</p>
      <p>超过350家公司，总投资金额超过35亿美金，</p>
      <p>其中70多家公司已经通过上市，并购或其他方式实现退出。</p>
    </div>
    <div class="index_down_button">
      <a-button type="ghost" shape="circle-outline" size="large">
        <template v-slot:icon>
          <DownOutlined/>
        </template>
      </a-button>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from "@ant-design/icons-vue/"
import {onMounted, reactive} from 'vue'

export default {
  name: 'Index_index_m',
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {  //跳转下一页
      document.documentElement.scrollBy({
        top: window.innerHeight,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.background_index_index {
  background-image: url("../../../assets/background/index_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

.index_text {
  padding-top: 20vh;
  height: 92vh;
}

.index_text p {
  font-size: 11px;
  margin-bottom: 0.5em;

}

.index_down_button {
  height: 5vh;
  position: relative;
  bottom: 2vh;
}

</style>
